export default __webpack_public_path__ + "static/media/previous.5edb9040.svg";